var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-particles',{attrs:{"id":"tsparticles","particlesInit":_vm.particlesInit,"particlesLoaded":_vm.particlesLoaded,"options":{
    fpsLimit: 120,
    interactivity: {
      events: {
        resize: true
      },
      modes: {
        bubble: {
          distance: 400,
          duration: 2,
          opacity: 0.8,
          size: 40
        },
        push: {
          quantity: 4
        },
        repulse: {
          distance: 200,
          duration: 0.4
        }
      }
    },
    particles: {
      number: {
        value: 25,
        density: {
          enable: true,
          value_area: 1400
        }
      },
      color: {
        value: '#ffffff'
      },
      shape: {
        type: 'edge',
        stroke: {
          width: 20,
          color: '#ffffff'
        }
      },
      opacity: {
        value: 0,
        random: false,
        anim: {
          enable: false,
          speed: 1,
          opacity_min: 0.1,
          sync: false
        }
      },
      size: {
        value: 60,
        random: true,
        anim: {
          enable: false,
          speed: 500,
          size_min: 0.1,
          sync: true
        }
      },
      line_linked: {
        enable: false,
        distance: 0,
        color: '#ffffff',
        opacity: 0,
        width: 0
      },
      move: {
        enable: true,
        speed: 1,
        direction: 'top',
        random: false,
        straight: true,
        out_mode: 'out',
        bounce: false
        //   attract: {
        //     enable: false,
        //     rotateX: 1200,
        //     rotateY: 1200
        //   }
      }
    },
    detectRetina: true
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }